export default __webpack_public_path__ + "static/media/avatar.6da98a13.png";